<template>
    <v-row class="white-card px-3">
        <v-col cols="12">
            <v-img class="mx-auto" width="69" contain :src="imgLogo"/>
        </v-col>
        <v-col cols="12" class="headline-heavy text-center">
            Mi Chequeo Anual
        </v-col>
        <v-col cols="12" class="subtitle-profile">
            Estudio básico correspondiente por edad
        </v-col>
        <v-col cols="12">
            <loading-spinner v-if="loadingExams"/>
            <exams-picker
                v-else
                :exams-options="examsAgesOptions"
                @change="examsAges = $event"
                :value="examsAges"
                list-mode
                return-object
                with-description
                ref="examsAgesPicker"
            />
        </v-col>
        <v-col cols="12" class="subtitle-profile" v-if="examsRecordsOptions.length > 0">
            En base a tu perfil de riesgo te recomendamos realizar los siguientes exámenes
        </v-col>
        <v-col cols="12" v-if="examsRecordsOptions.length > 0">
            <loading-spinner v-if="loadingExams"/>
            <exams-picker
                v-else
                :exams-options="examsRecordsOptions"
                @change="examsRecords = $event"
                :value="examsRecords"
                list-mode
                with-description
                return-object
                ref="examsRecordsPicker"
            />
        </v-col>
        <v-col cols="12" class="text-center my-5">
            <v-btn color="primary" outlined x-large depressed class="normal-btn mr-3" @click="onBack">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn color="secondary" x-large depressed class="normal-btn" :disabled="disabled"
                   @click="onContinue">
                Continuar
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import ExamsPicker from "@/components/exams/ExamsPicker"
import LoadingSpinner from "@/components/common/LoadingSpinner";
import httpService from "@/services/httpService";

export default {
    name: "ClientExamsSelector",
    components: {LoadingSpinner, ExamsPicker},
    props: {
        currentExams: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            examsAges: [],
            examsRecords: [],
            loadingExams: false,
            examsAgesOptions: [],
            examsRecordsOptions: [],
        }
    },
    computed: {
        disabled(vm = this) {
            return vm.exams.length === 0
        },
        exams(vm = this) {
            return [...vm.examsAges, ...vm.examsRecords]
        },
        age(vm = this) {
            if(!vm.currentUser?.birth_date) return null
            return vm.$moment().diff(vm.currentUser.birth_date, 'years')
        }
    },
    async mounted() {
        const vm = this
        await vm.loadExamsForClient()
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.currentExams?.length > 0) vm.setExams(vm.currentExams)
        },
        setExams(exams = []) {
            const vm = this
            vm.examsAges = exams.filter(exam => exam.ages.some(age => vm.age >= age.start && vm.age <= age.end))
            vm.examsRecords = exams.filter(exam => !exam.ages.some(age => vm.age >= age.start && vm.age <= age.end))
        },
        setExamsOptions(exams = []) {
            const vm = this
            vm.examsAgesOptions = exams.filter(exam => exam.ages.some(age => vm.age >= age.start && vm.age <= age.end))
            vm.examsRecordsOptions = exams.filter(exam => !exam.ages.some(age => vm.age >= age.start && vm.age <= age.end))
        },
        async loadExamsForClient() {
            const vm = this
            vm.loadingExams = true
            vm.examsAgesOptions = []
            vm.examsRecordsOptions = []
            vm.examsAges = []
            vm.examsRecords = []
            let response = await httpService.get(`users/${vm.currentUser.id}/suggested-exams`)
            // console.log('response loadExamsForClient',response)
            vm.setExamsOptions(response.data.exams)
            vm.setExams(response.data.exams)
            vm.loadingExams = false
        },
        onContinue() {
            const vm = this
            vm.$emit('success', vm.exams)
        },
        onBack() {
            const vm = this
            vm.$emit('back')
        }
    },
    watch: {
        currentExams() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.subtitle-profile {
    font-size: 17px;
    line-height: 20px;
    color: #939BB3;
}

</style>